exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv.stamp * {\n  padding: 2px;\n  /*color: #095b69 !important;*/\n  /*background-color: wheat !important;*/\n}\n\n/* .actions_btns .fa-cog {\n  color: #ffffff;\n} */\n@media screen and (max-width: 1200px) {\n}\n@media screen and (max-width: 769px) {\n.responsive-items button {\n    margin-left: 0px !important;\n    margin-right: 5px;\n    margin-bottom: 5px;\n}\n}\n", ""]);

// exports
